import { GlobalState } from '../reducers';

export const getLoadingState = (state: GlobalState): boolean => state.ui.loadingState;
